var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq38(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.850781,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0871,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.6746,
    y1: 12.1824,
    x2: 49.9109,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.00076,
    y1: 49.8543,
    x2: 12.2371,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.4367,
    y1: 38.6199,
    x2: 49.6731,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.762913,
    y1: 0.944118,
    x2: 11.9992,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.868 22.524C17.9333 21.6747 18.26 21.0073 18.848 20.522C19.4453 20.0273 20.2153 19.78 21.158 19.78C21.7833 19.78 22.32 19.892 22.768 20.116C23.216 20.34 23.552 20.648 23.776 21.04C24.0093 21.4227 24.126 21.8567 24.126 22.342C24.126 22.93 23.9533 23.4387 23.608 23.868C23.2627 24.2973 22.7727 24.5633 22.138 24.666V24.736C22.8007 24.8667 23.328 25.156 23.72 25.604C24.112 26.0427 24.308 26.6213 24.308 27.34C24.308 28.1427 24.0373 28.8007 23.496 29.314C22.964 29.818 22.1893 30.07 21.172 30.07C20.2013 30.07 19.4033 29.818 18.778 29.314C18.1527 28.8007 17.7933 28.0773 17.7 27.144H18.652C18.736 27.7693 18.9973 28.278 19.436 28.67C19.8747 29.0527 20.4533 29.244 21.172 29.244C21.8813 29.244 22.4227 29.0573 22.796 28.684C23.1787 28.3107 23.37 27.8347 23.37 27.256C23.37 25.8373 22.348 25.128 20.304 25.128H19.996V24.302H20.318C22.222 24.302 23.174 23.6813 23.174 22.44C23.174 21.8987 22.9967 21.4647 22.642 21.138C22.2873 20.802 21.7833 20.634 21.13 20.634C20.4953 20.634 19.968 20.802 19.548 21.138C19.1373 21.4647 18.8947 21.9267 18.82 22.524H17.868ZM28.0455 24.792C27.4668 24.6053 27.0235 24.3113 26.7155 23.91C26.4168 23.5087 26.2675 23.0233 26.2675 22.454C26.2675 21.95 26.3935 21.502 26.6455 21.11C26.9068 20.7087 27.2848 20.396 27.7795 20.172C28.2741 19.9387 28.8668 19.822 29.5575 19.822C30.2481 19.822 30.8408 19.9387 31.3355 20.172C31.8301 20.396 32.2035 20.7087 32.4555 21.11C32.7168 21.502 32.8475 21.95 32.8475 22.454C32.8475 23.014 32.6935 23.4993 32.3855 23.91C32.0868 24.3207 31.6481 24.6147 31.0695 24.792C31.7041 24.9507 32.2035 25.254 32.5675 25.702C32.9315 26.15 33.1135 26.696 33.1135 27.34C33.1135 27.9373 32.9641 28.46 32.6655 28.908C32.3761 29.3467 31.9608 29.6873 31.4195 29.93C30.8875 30.1727 30.2668 30.294 29.5575 30.294C28.8481 30.294 28.2228 30.1727 27.6815 29.93C27.1495 29.6873 26.7341 29.3467 26.4355 28.908C26.1461 28.46 26.0015 27.9373 26.0015 27.34C26.0015 26.696 26.1835 26.15 26.5475 25.702C26.9115 25.254 27.4108 24.9507 28.0455 24.792ZM31.8955 22.566C31.8955 21.95 31.6855 21.474 31.2655 21.138C30.8455 20.802 30.2761 20.634 29.5575 20.634C28.8388 20.634 28.2695 20.802 27.8495 21.138C27.4295 21.4647 27.2195 21.9407 27.2195 22.566C27.2195 23.1447 27.4341 23.6067 27.8635 23.952C28.2928 24.2973 28.8575 24.47 29.5575 24.47C30.2575 24.47 30.8221 24.2973 31.2515 23.952C31.6808 23.6067 31.8955 23.1447 31.8955 22.566ZM29.5575 25.226C28.7921 25.226 28.1668 25.3987 27.6815 25.744C27.1961 26.0893 26.9535 26.612 26.9535 27.312C26.9535 27.984 27.1868 28.5113 27.6535 28.894C28.1201 29.2767 28.7548 29.468 29.5575 29.468C30.3508 29.468 30.9808 29.2767 31.4475 28.894C31.9141 28.502 32.1475 27.9747 32.1475 27.312C32.1475 26.6213 31.9048 26.1033 31.4195 25.758C30.9435 25.4033 30.3228 25.226 29.5575 25.226Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq38);
export default __webpack_public_path__ + "static/media/fq38.264def8ae3510177aac48f81512ad313.svg";
export { ForwardRef as ReactComponent };